import { init } from "../model/car"

export function initApp() {
    return {
        type: "INIT",
        payload: init()
    }
}

export const setPlatformType = (platformType) => {
    return {
        type: "SET_PLATFORM_TYPE",
        payload: platformType
    }
}


// WEBPACK FOOTER //
// ./src/actions/appInitAct.js